import { type ReactNode } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';
import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import FactList from '@/karehero-app/tell-us-once/intake/FactList';
import {
  CARRIED,
  CALCULATOR_START,
} from '@/karehero-app/tell-us-once/benefits/BenefitsCalculator.content';
import { PAGE_HEADER_TOP } from '@/karehero-app/shell/layout';

// PROPOSED. The first screen of the calculator, and the reason it is not a
// form: it opens by saying what it already knows.
//
// The same fact list the review uses, because it is the same object. A calculator
// that opened on question one would ask three things the conversation already
// answered, and asking twice is how a person learns that telling us once was a
// promise about the form rather than about them.
const CarriedScreen = ({
  onStart,
  bar,
  content = CALCULATOR_START,
  carried = CARRIED,
}: {
  onStart: () => void;
  /** The calculator's app bar. Omit and the screen has none. */
  bar?: ReactNode;
  /** Whose first screen this is. The calculator's by default. */
  content?: {
    title: string;
    description?: string;
    primary: string;
    carriedNote?: string;
  };
  /** What we already hold, and where it came from. */
  carried?: typeof CARRIED;
}) => (
  <ScreenRoot relative>
    <StatusBar />
    {bar}

    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', px: 3, pb: 2 }}>
      <Stack sx={{ pt: PAGE_HEADER_TOP }} spacing={3}>
        <PageHeader
          title={content.title}
          description={content.description}
          variant='h2'
        />

        <FactList
          groups={[
            {
              label: carried.label ?? '',
              rows: carried.rows,
              note: content.carriedNote,
            },
          ]}
        />
      </Stack>
    </Box>

    <Box
      sx={{
        px: 3,
        pt: 1.5,
        pb: 0.5,
        bgcolor: 'background.default',
        borderTop: 1,
        borderColor: 'custom.neutral.200',
      }}
    >
      <Button
        variant='primary'
        size='lg'
        isFullWidth
        ariaLabel={content.primary}
        onPress={onStart}
      >
        {content.primary}
      </Button>
    </Box>

    <HomeIndicator />
  </ScreenRoot>
);

export default CarriedScreen;
